////import * as Sentry from '@sentry/react'; //// ENABLE SENTRY
import React from 'react';
import { render } from 'react-dom';
import { TopicAppContainer_ } from '../../../../components/app/TopicAppContainer_';
import { runtime } from '../../Runtime';
import { Menubar_ } from '../../../../areas/Menubar/Menubar_';
export class BrowserRender {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    get app() {
        return this.browserRuntime.app;
    }
    renderApp() {
        const TopicAppContainerWithSentry = TopicAppContainer_; //// Sentry.withProfiler(TopicAppContainer_);
        const appComp = React.createElement(TopicAppContainerWithSentry, { app: this.browserRuntime.app, key: Math.random() });
        render(appComp, document.getElementById('divContainer'), async () => {
            if (this.app.appInfo.isMobileAppWebView) {
                if (document.getElementById('divMenubar')) {
                    document.getElementById('divMenubar').remove();
                }
                return;
            }
            if (this.app.appInfo.isAppInEditBuild) {
                await Promise.all([runtime.fetchPackages.Edit, runtime.fetchPackages.Large]);
            }
            else if (this.app.menubar.isMenubarPhone) {
                // await runtime.fetchPackages.Mobile;  is small and in main bundle!
            }
            else {
                await runtime.fetchPackages.Large;
            }
            const menubarComp = React.createElement(Menubar_, { app: this.app });
            render(menubarComp, document.getElementById('divMenubar'));
        });
    }
}
if (module.hot) {
    module.hot.accept('../../../../components/app/TopicAppContainer_', () => {
        const TopicAppContainer_ = require('../../../../components/app/TopicAppContainer_').TopicAppContainer_;
        if (runtime.isBrowserRuntime) {
            console.log('trigger Render in Module.hot2');
            runtime.solidBrowserRuntime.browserRender.renderApp();
        }
    });
}
